import { CreateTicketLinkRequest, CreateTicketLinkResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export const createTicketLink = makeCloudFunction<
  CreateTicketLinkRequest,
  CreateTicketLinkResponse
>("ticketLink", "createTicketLink");
